import { useAuthStore } from "..";
import { showErrorToast } from "../components/ToastContainer";
import IUserActivationRequest from "../interfaces/IUserActivationRequest";

const useSendActivationData = (): (request: IUserActivationRequest) => Promise<void> => {
    const authStore = useAuthStore();

    return async (request: IUserActivationRequest): Promise<void> => {
        try {
            await authStore.sendActivationData(request);
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useSendActivationData;